import LocationsTable from "kinnect-front/Locations/LocationsTable";
import FullWidthLayout from "@/layouts/FullWidthLayout";
import { Location } from "kinnect-models";
import { FetchesData, Pageable } from "kinnect-mixins";
import { KTextField } from "kinnect-general";
import { VCard, VSheet } from "vuetify/lib";

export default {
	name: "LocationsPage",

	metaInfo: { title: "Locations" },

	mixins: [
		FetchesData,
		Pageable
	],

	data: () => ( {
		locations: [],
		search: ""
	} ),

	computed: {
		numLocations() {
			return this.locations.length;
		},

		toolbarActions() {
			if ( this.$can( "add_locations" ) ) {
				return {
					icon: "add_circle",
					text: "Add Location",
					to: { name: "locationAdd" },
					tooltip: "Add a new location"
				};
			}
		}
	},

	watch: {
		numLocations( numLocations ) {
			this.$store.dispatch( "breadcrumbs/setDetails", `${numLocations} locations` );
		}
	},

	methods: {
		async fetchLocations() {
			this.locations = await Location.get();
		},

		async fetch() {
			await this.fetchLocations();
		}
	},

	render() {
		return <FullWidthLayout>
			<VCard>
				<VSheet class="pa-3" color="primary" tile>
					<KTextField
						clearable
						dark
						flat
						hideDetails
						label="Search"
						prependInnerIcon="search"
						soloInverted
						vModel={this.search}
					></KTextField>
				</VSheet>

				<LocationsTable
					items={this.locations}
					loading={this.$wait.is( "get locations" )}
					search={this.search}
				></LocationsTable>
			</VCard>
		</FullWidthLayout>;
	}
};
